// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { observable, action, makeObservable } from 'mobx';
import { injectable } from 'inversify';

import ProfileService from '@shared/services/profile';
import StaffUser, { StaffUserDTO } from '@shared/models/staff-user';
import container from '@core/di';
import AuthStore from '@core/stores/auth';

@injectable()
export default class ProfileStore {
  static diToken = Symbol('profile-store');
  private service = container.get<ProfileService>(ProfileService.diToken);
  private authStore = container.get<AuthStore>(AuthStore.diToken);
  @observable user: StaffUser;

  constructor() {
    makeObservable(this);
  }

  @action get = async () => {
    try {
      const user = await this.service.get();
      user.update({ roles: this.authStore.user.roles });
      this.user = user;

      return user;
    } 
    catch (err) {
      throw err;
    }
  }

  @action edit = async (data: Partial<StaffUserDTO>) => {
    try {
      await this.service.edit(data);

      // Skip if only update alarms
      if (Object.keys(data).length > 1 || data.taskAlarms === undefined) {
        this.authStore.updateUser();
      }
      this.user.update(data);
    } catch (err) {
      throw err;
    }
  }
}